module.exports = __webpack_public_path__ + "img/store.6fcb5e09.png";